module.exports = __webpack_public_path__ + "img/badge-list-thumb-095.82aa1c50.png";